export {getStaticProps} from './index'
export {getStaticPaths} from './index'
import ExercisePage from './index'

export default ExercisePage
